import React from 'react';
const links = [{
  label: 'Terms',
  href: '#terms'
}, {
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Refund Policy',
  href: '#refund'
}, {
  label: 'Contact',
  href: 'mailto:hello@naileducatorready.com'
}];
export function SiteFooter() {
  return <footer className="bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-182" data-mp="35chibwi4daz7">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-183" data-mp="3a6c3l4ddhy0e">
        <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-184" data-mp="3f688r6xt3vhj">
          Nail Educator Ready™
        </p>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-185" data-mp="3o4k1pfm5b5d5">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-186" data-mp="3t33rjr3v11as">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-187" data-mp="oaiam02flvh">
        © 2026 Nail Educator Ready™. A digital teaching-resource system. It does not provide
        professional licensing, accreditation or government-recognized certification. Always follow
        the manufacturer instructions for the professional products and equipment you use. Payments
        are processed in your local currency.
      </p>
    </footer>;
}